namespace Solovis.Reports.Parts {

    export type PartControlSettings = {
        rowData?: string;
        groupBy?: Array<{ id: string }>;
        sortBy?: any;
        sorts?: any;
        isStickySortCallback?: boolean;
        columnVisibilityInitialFilterCreator?: any;
        hideIfNoRows?: boolean;
        noDeferredRender?: boolean;
        noFloatingHScroll?: boolean;
        marginCentered?: boolean;
        rowStyleUpdater?: any | null;
        aggregateRow?: { display?: string, groupHeaderColspan?: number };
        columns?: () => Array<any>;
        subRowGroupKeyGetter?: (row: { index: string }) => string;
        subRowFactory?: (row: any) => any;
        keepGroupSubRowsOnCollapse?: boolean;
        groups?: Solovis.Reports.Parts.Tables.DataTableHelpers.GroupManagerOptions["groups"];
        modelEnvironment?: { path?: string };
        cellContextMenuItems: typeof Solovis.Reports.ReportHelpers.ReportBuilderHelpers.getCellContextMenuItems;
        printOnly?: boolean;
        usePersistedSettings?: boolean;
        reportOptions?: (() => any) | Record<string, any>;
        tabs?: (() => Array<any>) | Array<any>;
        aggregates?: Array<any>;

        // HtmlControl specific settings
        html?: string;
        cleanHtml?: boolean;
        noClearBeforeRender?: boolean;
        getPersistedSettings?: () => any;
        render?: () => any;
        destroy?: () => any;
    } & Solovis.Reports.Parts.Tables.DataTablePartSettings;

    export interface PartControlOptions extends Solovis.UI.BaseControl {
        reportControl: Solovis.Reports.ReportControl;
        partElementName?: string;
        settings?: PartControlSettings;
        persistedSettings?: Partial<PartControlSettings>;

        /**
         * If set, parameterOverrides should be utilized as the parameters set on this report regardless of what reportControl reports.
         */
        parameterOverrides?: any;

        // function that will be called with the part control as the this parameter. Must retun boolean
        // to indicate whether the control should be visible or not.
        visible?: any;
    }

    export class PartControl extends Solovis.UI.BaseControl {

        public reportControl: Solovis.Reports.ReportControl;
        public partElementName: string;
        public settings: PartControlSettings;

        public _visibilityTest: any;
        public _parentIsVisible: boolean;
        public isVisible: boolean;
        public _initiallyHiddenContainer: boolean;

        public printMode: any;
        public parameters: any;
        public dataSets: any;

        public _originalControlHostDisplay: any;


        constructor(options: PartControlOptions) {
            super(options);

            var self = this;

            this.transition = null;

            this.reportControl = options.reportControl;
            this.partElementName = options.partElementName;
            this.settings = options.settings;

            this._visibilityTest = options.visible ? options.visible : null;
            this._parentIsVisible = false;

            this.isVisible = false;
            // Tell BaseControl that the this.container element should initially be created with display:none
            this._initiallyHiddenContainer = true;
            
            this.printMode = null;
            this.parameters = options.parameterOverrides ? options.parameterOverrides : null;
            this.dataSets = null;

            this._originalControlHostDisplay = null;

            $(this).bind("renderComplete", function () {
                self.onVisibilityChanged();
            });
        }


        public setPrintMode(newPrintMode) {
            this.printMode = newPrintMode;
        }

        /**
         * Called by ReportControl infrastructure when parameters are updated.
         * @param newParameters
         */
        public updateParameters(newParameters) {            
            if (!(this.options as PartControlOptions).parameterOverrides) {
                this.parameters = newParameters;
            }
        }

        /**
         * Called by ReportControl infrastructure when all data sets needed by PartControl are available.
         * @param newParameters
         */
        public updateDataSets(dataSets) {
            this.dataSets = dataSets;

            if (this.state >= Solovis.UI.BaseControl.ControlState.beforeRender) {
                (this as any).doRender();
            }
        }

        public updateParentVisibility(isVisible) {
            this._parentIsVisible = isVisible;

            this._updateVisibility();
        }

        public _updateVisibility() {
            var wantsToBeVisible = true;
            if (this._visibilityTest) {
                wantsToBeVisible = this._visibilityTest.call(this);
            }

            let partHiddenOverrideSet = this.reportControl.isPartHiddenOverrideSet(this.partElementName);

            var shouldBeVisible = wantsToBeVisible && this._parentIsVisible && !partHiddenOverrideSet;

            if (shouldBeVisible != this.isVisible) {
                this.isVisible = shouldBeVisible;
                this.onVisibilityChanged();
            }
        }

        public onVisibilityChanged() {
            if (this.controlHost && this.controlHost.container) {
                // We update visibility on the controlHost container too because that is where part container styles
                //   are applied for margin, border, etc. that should go away if the part is hidden.
                if (this.isVisible) {
                    var currentDisplay = this.controlHost.container.css("display");
                    if (currentDisplay == "none") {
                        var newDisplay = this._originalControlHostDisplay ? this._originalControlHostDisplay : "block";
                        this.controlHost.container.css("display", newDisplay);
                    }
                }
                else {
                    if (this._originalControlHostDisplay === null) {
                        // We remember this so we can restore float vs block.
                        this._originalControlHostDisplay = this.controlHost.container.css("display");
                    }
                    this.controlHost.container.css("display", "none");
                }
            }
            else {
                this._initiallyHiddenContainer = !this.isVisible;
            }

            if (this.container) {
                if (this.isVisible) {
                    this.container.css("display", "block");
                }
                else {
                    this.container.css("display", "none");
                }
            }
            else {
                this._initiallyHiddenContainer = !this.isVisible;
            }
        }

    }

}

    